import React from "react"
import FieldProto_FormElement from "../../../proto/render/form-element";
import FieldRating_InlineEditableStatefull from "../components/inline-edit/rating-component";

export default class FieldRating_FormElement extends FieldProto_FormElement {

    render() {

        return <FieldRating_InlineEditableStatefull className    = {this.props.className}
                                                    field        = {this.props.field}
                                                    value        = {this.value}
                                                    disabled     = {this.props.disabled}
                                                    onChange     = {this.onChange}/>

        // return <FieldToggle_ComponentStatefull className="no-margin"
        //                                 field={this.props.field}
        //                                 disabled={this.props.disabled}
        //                                 size="20"
        //                                 value={this.value}
        //                                        onChange={this.onChange}/>
    }

}